__turbopack_context__.v({
  "body": "cQAk4W_body",
  "content": "cQAk4W_content",
  "description": "cQAk4W_description",
  "icon": "cQAk4W_icon",
  "iconSlot": "cQAk4W_iconSlot",
  "innerCollapsed": "cQAk4W_innerCollapsed",
  "label": "cQAk4W_label",
  "labelFullWidthRow": "cQAk4W_labelFullWidthRow",
  "labelWrapperFill": "cQAk4W_labelWrapperFill",
  "largeBody": "cQAk4W_largeBody",
  "largeIconSlot": "cQAk4W_largeIconSlot",
  "largeIconSlotImg": "cQAk4W_largeIconSlotImg",
  "largeRadio": "cQAk4W_largeRadio",
  "radio": "cQAk4W_radio",
  "rootCard": "cQAk4W_rootCard",
  "rootPill": "cQAk4W_rootPill",
  "rootRow": "cQAk4W_rootRow",
  "rootShell": "cQAk4W_rootShell",
});
